/**
 * Provozní a obchodní údaje, které se na webu zobrazují jako fakta.
 *
 * Všechno tady musí odpovídat skutečnosti – zákon o ochraně spotřebitele
 * zakazuje klamavá tvrzení a vymyšlená hodnocení. Když si nejste jistí,
 * údaj raději vynechte.
 */
import { REVIEWS } from './contact';

// Pracovní doba – JEDINÝ zdroj pro patičku, /kontakt i strukturovaná data.
// Dřív byla rozepsaná na několika místech a formulář tvrdil „Pracujeme 7 dní
// v týdnu", zatímco /kontakt „Neděle zavřeno".
// TODO(majitel): potvrdit skutečnou pracovní dobu a zda se pracuje o víkendu.
export const HOURS = [
  { label: 'Pondělí – Pátek', short: 'Po–Pá', days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'], opens: '08:00', closes: '18:00' },
  { label: 'Sobota', short: 'So', days: ['Saturday'], opens: '09:00', closes: '15:00' },
  { label: 'Neděle', short: 'Ne', days: ['Sunday'], opens: null, closes: null },
];

const hhmm = (t) => t.replace(/^0/, '');
export const hoursText = (h) => (h.opens ? `${hhmm(h.opens)} – ${hhmm(h.closes)}` : 'Zavřeno');

// Krátké shrnutí, např. „Po–Pá 8:00–18:00 · So 9:00–15:00"
export const hoursSummary = () => HOURS
  .filter((h) => h.opens)
  .map((h) => `${h.short} ${hhmm(h.opens)}–${hhmm(h.closes)}`)
  .join(' · ');

export const openingHoursSchema = () => HOURS
  .filter((h) => h.opens)
  .map((h) => ({
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: h.days.length === 1 ? h.days[0] : h.days,
    opens: h.opens,
    closes: h.closes,
  }));

// Ceny: SeknuTo.cz záměrně NEZVEŘEJŇUJE žádné ceny „od" ani orientační částky.
// Rozhodnutí majitele (10/2026): každá zakázka je jiná, cenu řekneme až po
// bezplatné obhlídce (nebo z fotky přes WhatsApp) – předem a bez skrytých
// poplatků. Na web proto nepatří žádná čísla v Kč za m², metr ani strom.
export const PRICE_POLICY = 'Cena vždy po bezplatné obhlídce – předem, závazně a bez skrytých poplatků.';

// Počítadla na homepage. `value` se v HTML ukazuje přesně takhle (prerender),
// animace od nuly je jen vizuální efekt.
export const STATS = [
  // TODO(majitel): potvrdit, že „50+" odpovídá skutečnému počtu zákazníků
  { value: '50+', label: 'Spokojených zákazníků' },
  { value: '0 Kč', label: 'Obhlídka a nacenění' },
  { value: '24h', label: 'Odpověď na poptávku' },
  { value: `${String(REVIEWS.rating).replace('.', ',')}★`, label: `Hodnocení na ${REVIEWS.label}` },
];
